"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mainUIBlockTemplate = void 0;
var tslib_1 = require("tslib");
var mainUIBlock_dot_1 = (0, tslib_1.__importDefault)(require("./mainUIBlock.dot"));
var mainUIBlockTemplate = mainUIBlock_dot_1.default.default ? mainUIBlock_dot_1.default.default : mainUIBlock_dot_1.default;
exports.mainUIBlockTemplate = mainUIBlockTemplate;
//# sourceMappingURL=index.js.map